import { Button, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as AddIcon } from "@king-ict/eupisi-ui/components/Icon/Add.svg";
import { ReactComponent as RemoveIcon } from "@king-ict/eupisi-ui/components/Icon/RemoveIcon.svg";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { OtherEnrollmentCondition } from "../../models/ProgramRequest";
import styles from "./ProgramRequestEdit.module.scss";

export interface OtherEnrollmentConditionsInfoProps {
  name: string;
  otherEnrollmentConditions: string[];
  readonly?: boolean;
  getErrorForPath: (path: string) => string | undefined;
  onChange: (e: any) => void;
}

export function OtherEnrollmentConditionsInfo({
  name,
  otherEnrollmentConditions,
  readonly = false,
  getErrorForPath,
  onChange
}: OtherEnrollmentConditionsInfoProps) {
  const { t } = useTranslation();

  const handleAdd = (event: React.MouseEvent<any, MouseEvent>) => {
    var newList = otherEnrollmentConditions.slice();
    newList.push("");
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    var newList = otherEnrollmentConditions.slice();
    newList[index] = event.target.value;
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  const handleRemove = (event: React.MouseEvent<any, MouseEvent>, index: number) => {
    var newList = otherEnrollmentConditions.slice();
    newList.splice(index, 1);
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  return (
    <>
      <Row>
        <Col md={12} className={styles.rowTitleSpacing}>
          <Typography variant="smallHeading" component="h3">
            {t("request.enrollmentConditions")}
          </Typography>
        </Col>
      </Row>
      <Row className={styles.rowSpacing}>
        {otherEnrollmentConditions.map((oec, oecIndex) => (
          <Col md={12}>
            <Row>
              <Col
                md={12}
                className={styles.otherEnrollmentConditionFieldRow}
              >
                <div
                  className={styles.otherEnrollmentConditionTextField}
                >
                  <TextField
                    label={t("request.otherEnrollmentConditions")}
                    value={oec}
                    maxLength={512}
                    onChange={(e) => handleChange(e, oecIndex)}
                    errorText={getErrorForPath(`otherEnrollmentConditions${oecIndex}`)}
                    plaintext={readonly}
                  />
                </div>
                {!readonly &&
                  <div
                    className={
                      styles.otherEnrollmentConditionRemoveField
                    }
                  >
                    <Button
                      boxless
                      onClick={(e) => handleRemove(e, oecIndex)}
                      disabled={otherEnrollmentConditions.length <= 1}
                    >
                      <RemoveIcon />
                    </Button>
                  </div>
                }
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
      {!readonly &&
        <Row className={styles.addDataButtonCol}>
          <Col md={12}>
            <Button
              disabled={otherEnrollmentConditions.length >= 10}
              outline
              icon={<AddIcon />}
              onClick={handleAdd}
            >
              {t("request.addNewEnrollmentCondition")}
            </Button>
          </Col>
        </Row>
      }
    </>
  )
}